<template>
  <div>
    <!-- <div class="absolute bg-faq-dots z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-dots.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div>
    <div class="absolute bg-faq-poly1 z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-poly1.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div>
    <div class="absolute bg-faq-poly2 z-index--1 mob-hidden">
      <img
        src="../../../assets/images/caregiver/faq-poly2.svg"
        alt="bg-polygon"
        class="w-full"
      />
    </div> -->
    <div class="lg:px-12 md:px-12 px-4 pt-5 mb-5">
      <p
        class="title w-full sm-fsize16 md:font-normal lg:font-normal font-bold"
      >
        FAQ's
      </p>
      <div
        class="md:mt-6 lg:mt-6 mt-4 md:py-6 lg:py-6 py-4 md:px-8 lg:px-8 px-4 cust-shadow-FAQ rounded-lg bg-white z-10"
        v-for="(item, index) in faq"
        :key="index"
      >
        <div
          class="flex items-center w-full justify-between cursor-pointer"
          block
          v-b-toggle="'accordion-' + index"
        >
          <p class="subtitle px-2 txt-FAQ-A fsize20-14px">
            {{ item.que }}
          </p>
          <img
            src="../../../assets/images/caregiver/downIcon.svg"
            alt="Downicon"
            class="md:h-4 lg:h-4 h-2 w-6"
          />
        </div>
        <b-collapse
          :id="'accordion-' + index"
          accordion="my-accordion"
          role="tabpanel"
        >
          <p class="subtitle px-2 pt-8 fsize20-14px">
            {{ item.answer }}
          </p>
        </b-collapse>
      </div>
      <!-- <div
        class="
          md:mt-10
          lg:mt-10
          mt-4
          md:py-6
          lg:py-6
          py-4
          md:px-8
          lg:px-8
          px-4
          cust-shadow-FAQ
          rounded-lg
          bg-white
          z-10
        "
        v-for="(item, index) in faq"
        :key="index"
      >
        <div
          class="flex items-center w-full justify-between cursor-pointer"
          block
          v-b-toggle.accordion-4
        >
          <p class="subtitle txt-FAQ-A fsize20-14px">
            {{ item.que }}
          </p>
          <img
            src="../../../assets/images/caregiver/downIcon.svg"
            alt="Downicon"
            class="md:h-4 lg:h-4 h-2 w-6"
          />
        </div>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
          <p class="subtitle pt-8 fsize20-14px">
            {{ item.answer }}
          </p>
        </b-collapse>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      faq: [
        {
          id: "01",
          que: "What is Respite Care?",
          answer:
            "As caregivers we need respite from the 24x7 responsibilities as they can be exhausting. When you want a short break or you want your caregiver to have a short break, so that they can have the time for recreation and replenishment. You can request for appropriate Respite care services.",
        },
        {
          id: "02",
          que: "How does it  work?",
          answer:
            "As a subscriber, you can request for respite care service by booking an appointment with the various service providers. Respite care can be online or offline. Person assigned will visit your place,  follow a checklist of predefined tasks to perform. Once the defined task is completed,  we will request you for a confirmation and  feedback for the service provider.",
        },
        {
          id: "03",
          que: "How do you book an appointment?",
          answer:
            "You can book an appointment in easy 3 steps, Step1: Search for a service provider according to your locatoin and type of service. Step 2: Identify an appropriate service provider as per mutual availability. Step 3: Select the date and time you want the service on and your booking will be confirmed.",
        },
        {
          id: "04",
          que: "What happens after you book an appointment?",
          answer:
            "After you book an appointment, you will receive a confirmation mail (SMS) for the appointment booked and on the day of booking a service provider will attend to you for the respite care with the predefined tasks.",
        },
        {
          id: "05",
          que: "What do you need to be mindful of when you avail a Respite Care?",
          answer:
            "Please make sure that when you avail the offline services, there is someone else in the home for emergency care. In case you want support for a vulnerable person and are concerned about emergencies then we recommend that you call the helpline with your specific requirements and we will do our best to support you.",
        },
        {
          id: "06",
          que: "What if i don't find a required service as per my location?",
          answer:
            "We are building our team and services and are available in some places. We hope to expand our services over a period of time.  You can request for a custom service requirement by simply filling out a form on the navigation bar.",
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
